import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FaTable, FaChartBar, FaTags, FaCreditCard, FaCog, FaPlus, FaList, FaFileImport, FaWallet, FaChartPie, FaChartLine, FaHome } from 'react-icons/fa';

const Header = () => {
  return (
    <Navbar className="excel-navbar" expand="lg" variant="dark">
      <Container>
        <Navbar.Brand as={NavLink} to="/" className="fw-bold">
          <FaTable className="me-2" />
          2centavos
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto">
            {/* Dashboard - direto */}
            <Nav.Link as={NavLink} to="/dashboard" className="excel-menu-item">
              <FaChartBar className="me-1" /> Dashboard
            </Nav.Link>
            
            {/* Transações - submenu */}
            <NavDropdown 
              title={<><FaTable className="me-1" /> Transações</>} 
              id="transactions-dropdown"
              className="excel-menu-dropdown"
            >
              <NavDropdown.Item as={NavLink} to="/transactions" className="excel-dropdown-item">
                <FaList className="me-2" /> Listar Transações
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/transactions/new" className="excel-dropdown-item">
                <FaPlus className="me-2" /> Nova Transação
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to="/transactions?import=true" className="excel-dropdown-item">
                <FaFileImport className="me-2" /> Importar Transações
              </NavDropdown.Item>
            </NavDropdown>
            
            {/* Configurações - submenu */}
            <NavDropdown 
              title={<><FaCog className="me-1" /> Configurações</>} 
              id="settings-dropdown"
              className="excel-menu-dropdown"
            >
              <NavDropdown.Item as={NavLink} to="/categories" className="excel-dropdown-item">
                <FaTags className="me-2" /> Categorias
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/credit-cards" className="excel-dropdown-item">
                <FaCreditCard className="me-2" /> Cartões de Crédito
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to="/initial-balance" className="excel-dropdown-item">
                <FaWallet className="me-2" /> Saldo Inicial
              </NavDropdown.Item>
            </NavDropdown>
            
            {/* Relatórios - submenu */}
            <NavDropdown 
              title={<><FaChartPie className="me-1" /> Relatórios</>} 
              id="reports-dropdown"
              className="excel-menu-dropdown"
            >
              <NavDropdown.Item as={NavLink} to="/reports" className="excel-dropdown-item">
                <FaHome className="me-2" /> Central de Relatórios
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={NavLink} to="/reports/category" className="excel-dropdown-item">
                <FaTags className="me-2" /> Por Categoria
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/reports/category-analysis" className="excel-dropdown-item">
                <FaChartPie className="me-2" /> Análise por Categoria
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/reports/temporal-analysis" className="excel-dropdown-item">
                <FaChartLine className="me-2" /> Análise Temporal
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header; 